import { ResponseMap } from '@/shared/libs';

export default function errorMapper(vm, e) {
  const errors = {};

  const ERROR_FIELD_GLOBAL = 'global';
  const CODE_CAPTCHA_MISMATCH = 'CAPTCHA_MISMATCH';
  const CODE_CAPTCHA_BLANK = 'CAPTCHA_BLANK';

  const closableMessages = {
    HTTP_SESSION_LIMIT_EXCEEDED: 'HTTP_SESSION_LIMIT_EXCEEDED',
  };

  const messages = {
    AGREEMENTS_NOT_ALL_ACCEPTED: vm.$t('subscriber.errors.agreementsNotAllAccepted'),
    BACKOFFICE_UNAVAILABLE: vm.$t('subscriber.errors.backOfficeUnavailable'),
    CAPTCHA_BLANK: vm.$t('subscriber.errors.captchaBlank'),
    CAPTCHA_MISMATCH: vm.$t('subscriber.errors.captchaMismatch'),
    SUBSCRIBER_DATE_OF_BIRTH_BLANK: vm.$t('subscriber.errors.dateOfBirthBlank'),
    SUBSCRIBER_DATE_OF_BIRTH_INVALID: vm.$t('subscriber.errors.dateOfBirthInvalid'),
    SUBSCRIBER_EXTERNAL_TOKEN_INVALID: vm.$t('subscriber.errors.subscriberExternalTokenInvalid'),
    SUBSCRIBER_FORGOT_PASSWORD_LIMIT_EXCEEDED: vm.$t('subscriber.errors.subscriberForgotPasswordLimitExceeded'),
    SUBSCRIBER_GENDER_BLANK: vm.$t('subscriber.errors.genderBlank'),
    SUBSCRIBER_PASSWORD_BLANK: vm.$t('subscriber.errors.subscriberPasswordBlank'),
    SUBSCRIBER_PASSWORD_CHANGE_LIMIT_EXCEEDED: vm.$t('subscriber.errors.subscriberPasswordChangeLimitExceeded'),
    SUBSCRIBER_NOT_VERIFIED: vm.$t('subscriber.errors.subscriberNotVerified'),
    SUBSCRIBER_INVALID_LOGIN_OR_PASSWORD: vm.$t('subscriber.errors.subscriberInvalidLoginOrPassword'),
    SUBSCRIBER_INVALID_PASSWORD: vm.$t('subscriber.errors.subscriberInvalidPassword'),
    SUBSCRIBER_INVALID_PIN: vm.$t('subscriber.errors.subscriberInvalidPin'),
    SUBSCRIBER_INVALID_REGION: vm.$t('subscriber.errors.subscriberInvalidRegion'),
    FACEBOOK_ERROR: vm.$t('subscriber.errors.facebookError'),
    SUBSCRIBER_EMAIL_BLANK: vm.$t('subscriber.errors.subscriberEmailBlank'),
    SUBSCRIBER_EMAIL_EXISTS: vm.$t('subscriber.errors.subscriberEmailExists'),
    DATE_INVALID_FORMAT: vm.$t('subscriber.errors.dateInvalidFormat'),
    COMMON_INVALID_EMAIL: vm.$t('subscriber.errors.commonInvalidEmail'),
    CONTACT_CONTENT_BLANK: vm.$t('subscriber.errors.contactContentBlank'),
    CONTACT_PROCESS_DATA: vm.$t('subscriber.errors.contactProcessData'),
    CONTACT_NAME_BLANK: vm.$t('subscriber.errors.contactNameBlank'),
    CONTACT_SENDER_EMAIL_BLANK: vm.$t('subscriber.errors.contactSenderEmailBlank'),
    CONTACT_TITLE_BLANK: vm.$t('subscriber.errors.contactTitleBlank'),
    SUBSCRIBER_LOGIN_EXISTS: vm.$t('subscriber.errors.subscriberLoginExists'),
    PASSWORD_BLANK: vm.$t('subscriber.errors.passwordBlank'),
    PASSWORD_REPEAT_INVALID: vm.$t('subscriber.errors.passwordRepeatInvalid'),
    PASSWORD_TOO_LESS_UNIQUE_CHARACTERS: vm.$t('subscriber.errors.passwordTooLessUniqueCharacters'),
    PASSWORD_INVALID_LENGTH: vm.$t('subscriber.errors.passwordInvalidLength'),
    PASSWORD_SAME_AS_CURRENT: vm.$t('subscriber.errors.passwordSameAsCurrent'),
    PASSWORD_EQUIVALENT: vm.$t('subscriber.errors.passwordEquivalent'),
    PASSWORD_COMMON: vm.$t('subscriber.errors.passwordCommon'),
    SUBSCRIBER_EXTERNAL_UID_EXISTS: vm.$t('subscriber.errors.subscriberExternalUidExists'),
    SUBSCRIBER_INVALID_OLD_PASSWORD: vm.$t('subscriber.errors.subscriberOldPasswordInvalid'),
    SUBSCRIBER_VERIFY_MAIL_TOKEN_NOT_EXISTS: vm.$t('subscriber.errors.subscriberVerifyMailTokenNotExists'),
    SUBSCRIBER_VERIFY_MSISDN_TOKEN_NOT_EXISTS: vm.$t('subscriber.errors.subscriberVerifyMsisdnTokenNotExists'),
    SUBSCRIBER_NOT_EXISTS: vm.$t('subscriber.errors.subscriberNotExists'),
    SUBSCRIBER_PASSWORD_TOKEN_NOT_EXISTS: vm.$t('subscriber.errors.subscriberPasswordTokenNotExists'),
    SUBSCRIBER_TOKEN_NOT_EXISTS: vm.$t('subscriber.errors.subscriberTokenNotExists'),
    SUBSCRIBER_TOKEN_EXPIRED: vm.$t('subscriber.errors.subscriberTokenNotExpired'),
    SUBSCRIBER_NEW_PASSWORD_BLANK: vm.$t('subscriber.errors.subscriberNewPasswordBlank'),
    HTTP_SESSION_LIMIT_EXCEEDED: vm.$t('subscriber.errors.httpSessionLimitExceeded'),
    SUBSCRIBER_CREDENTIALS_EMPTY: vm.$t('subscriber.errors.subscriberCredentialsEmpty'),
    SUBSCRIBER_EMAIL_AND_MSISDN_CONFLICT: vm.$t('subscriber.errors.subscriberEmailAndMsisdnConflict'),
    SUBSCRIBER_ID_AND_BSS_ID_NULL: vm.$t('subscriber.errors.subscriberIdAndBssIdNull'),
    SUBSCRIBER_IS_SUSPENDED: vm.$t('subscriber.errors.subscriberIsSuspended'),
    SUBSCRIBER_LOGIN_BLANK: vm.$t('subscriber.errors.subscriberLoginBlank'),
    SUBSCRIBER_LOGIN_INVALID: vm.$t('subscriber.errors.subscriberLoginInvalid'),
    SUBSCRIBER_MSISDN_INVALID: vm.$t('subscriber.errors.subscriberMsisdnInvalid'),
    SUBSCRIBER_NOT_BELONG_TO_TENANT: vm.$t('subscriber.errors.subscriberNotBelongToTenant'),
    SUBSCRIBER_MSISDN_EXISTS: vm.$t('subscriber.errors.subscriberMsisdnExists'),
    SUBSCRIBER_MSISDN_BLANK: vm.$t('subscriber.errors.subscriberMsisdnBlank'),
    SUBSCRIBER_PASSWORD_RESET_REQUIRED: vm.$t('subscriber.errors.subscriberPasswordResetRequired'),
    SSO_PASSWORD_POLICY: vm.$t('subscriber.errors.ssoPasswordPolicy'),
    COMMON_INVALID_MSISDN: vm.$t('subscriber.errors.commonInvalidMsisdn'),
    MSISDN_COUNRTY_PREFIX_INVALID: vm.$t('subscriber.errors.msisdnCountryPrefixInvalid'),
    UNKNOWN_ERROR: vm.$t('subscriber.errors.unknownError'),
    PIN_NEW_REPEAT_INVALID: vm.$t('subscriber.errors.pinRepeatInvalid'),
    SUBSCRIBER_INVALID_PIN_FORMAT: vm.$t('subscriber.errors.invalidPin'),
    PROFILE_ADULT_REQUIRED: vm.$t('subscriber.errors.profileAdultRequired'),
    PROFILE_ALREADY_EXISTS: vm.$t('subscriber.errors.profileAlreadyExists'),
    PROFILE_LAST_CHANGE_TO_KIDS_PROHIBITED: vm.$t('subscriber.errors.profileLastChangeToKidsProhibited'),
    PROFILE_LIMIT_EXCEEDED: vm.$t('subscriber.errors.profileLimitExceeded'),
    PROFILE_NAME_LENGTH_LIMIT_EXCEEDED: vm.$t('subscriber.errors.profileNameLengthLimitExceeded'),
    GEOIP_FILTER_FAILED: vm.$t('subscriber.errors.geoipFilterFailed'),
    GEOIP_FILTER_EU_AND_NOT_VERIFIED: vm.$t('subscriber.errors.geoipFilterFailed'),
    GEOIP_FILTER_OUTSIDE_EU_AND_EEA: vm.$t('subscriber.errors.geoipFilterFailed'),
    VERIFICATION_CODE_INVALID: vm.$t('subscriber.errors.verificationCodeInvalid'),
    VERIFICATION_CODE_EXPIRED: vm.$t('subscriber.errors.verificationCodeExpired'),
    VERIFICATION_LIMIT_EXCEEDED: vm.$t('subscriber.errors.verificationLimitExceeded'),

    // TV
    OTC_NOT_EXISTS: vm.$t('subscriber.errors.oauthOneTimeCodeInvalid'),
    DEVICE_NOT_EXISTS: vm.$t('subscriber.errors.deviceNotExists'),
    OTC_EXPIRED: vm.$t('subscriber.errors.oauthOneTimeCodeExpired'),
  };

  const message = (code) => {
    const message = messages[code];

    if (message) {
      if (closableMessages[code]) {
        errors.closable = true;
      }
      return message;
    }

    errors.closable = true;
    return messages.UNKNOWN_ERROR;
  };

  const get = () => {
    let data = {};
    if (e && e.response && e.response.data) {
      data = e.response.data;
    } else if (e && e.data) {
      data = e.data;
    }

    const dataErrors = data.errors || [data];

    dataErrors.forEach(({ id, code, field = ERROR_FIELD_GLOBAL }) => {
      if (code === CODE_CAPTCHA_MISMATCH || code === CODE_CAPTCHA_BLANK) {
        field = 'captcha';
      }

      const prefix = id ? `${id}: ` : '';
      errors[field] = prefix + message(code);

      if (field === ERROR_FIELD_GLOBAL) {
        errors.code = code;
      }
    });

    if (Object.entries(errors).length === 0) {
      throw new Error('Unknown error');
    }

    return errors;
  };

  if (e.response && e.response.status === 403) {
    const code = e.response.code || e.response.data.code;
    if (ResponseMap[code]) {
      return Promise.resolve({});
    }
  }

  // When error in error handling occurs...
  try {
    return Promise.resolve(get());
  } catch (ignore) {
    return Promise.resolve({ global: messages.UNKNOWN_ERROR });
  }
}
